import type { CmsProps } from '../../../types/cms'
import styled from '@emotion/styled'
import isPropValid from '@emotion/is-prop-valid'
import { Stack } from '@mui/material'

export const InfoContainer = styled(Stack, {
  shouldForwardProp: prop => isPropValid(prop) && prop !== 'textColour',
})<CmsProps>`
  padding: 2.5rem 0;

  && h1,
  && h2,
  && h3,
  && h4 {
    color: ${({ textColour }) => textColour ?? '#000'};
    margin-top: 0.67em;
    margin-bottom: 0.67em;
  }

  && p {
    color: ${({ textColour }) => textColour ?? '#000'};
    margin-top: 1em;
    margin-bottom: 1em;
  }
`

export const ProductsBackground = styled.section<CmsProps>`
  background: ${({ backgroundImage }) =>
    `url(${backgroundImage}) center center no-repeat`};
  background-size: cover;
`
